import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBoard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBoard"><Path d="M3 21V3H11V21L3 21Z" fill="currentColor"/><Path d="M12.5 21L21 21V12.75H12.5V21Z" fill="currentColor"/><Path d="M21 11.25V3H12.5V11.25H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBoard;
